function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, computed, watch, onMounted } from "vue";
import { getAssetTagList } from "@/api/public_resource";
import { definePropType } from "@types-vue/props";
import { Operation } from "../label/label-config";
import store from "@/store";
export default defineComponent({
    name: "tag-cascader",
    props: {
        config: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        },
        formValue: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var cascaderRef = ref();
        var tagOptions1 = ref([]);
        var defaultProps = computed(function() {
            return {
                children: "sub_tag_groups",
                checkStrictly: !props.config.isMultiple,
                emitPath: false,
                label: "name",
                value: "id",
                multiple: props.config.isMultiple
            };
        });
        var innerConfig = computed(function() {
            var params = _objectSpread({
                valueKey: "id"
            }, props.config.params);
            params.data = tagOptions1.value;
            return _objectSpreadProps(_objectSpread({}, props.config), {
                params: params
            });
        });
        var handleChange = function() {
            // 标签组改变位置
            if (props.config.treeParams.group_type === 1) {
                var _$ref, _$ref1;
                var data = (_$ref1 = (_$ref = cascaderRef.value) === null || _$ref === void 0 ? void 0 : _$ref.getCheckedNodes()[0]) === null || _$ref1 === void 0 ? void 0 : _$ref1.data;
                store.state.resource.cascaderValue = {
                    id: data.id,
                    level: data.level,
                    change: true
                };
            }
            emit("handleChange");
        };
        // 标签值只能加在末级标签组上
        var getTreeList = function(tagOptions) {
            tagOptions.forEach(function(item) {
                if (item.is_leaf !== 1) {
                    item.disabled = true;
                } else {
                    item.disabled = false;
                }
                if (item.sub_tag_groups) {
                    getTreeList(item.sub_tag_groups);
                }
            });
        };
        // 标签组二级修改禁用自身选项
        var getGroupList = function(tagOptions) {
            tagOptions.forEach(function(item) {
                if (item.sub_tag_groups) {
                    item.sub_tag_groups.forEach(function(val) {
                        if (val.id === props.formValue.id) {
                            val.disabled = true;
                        }
                    });
                }
            });
        };
        var initTreeData = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var _treeParams, res, _tag_groups;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            store.state.resource.cascaderValue = {
                                id: props.formValue.pid,
                                level: props.formValue.level,
                                change: false
                            };
                            ;
                            _ctx.next = 4;
                            return getAssetTagList((_treeParams = props.config.treeParams) !== null && _treeParams !== void 0 ? _treeParams : "");
                        case 4:
                            res = _ctx.sent;
                            ;
                            tagOptions1.value = (_tag_groups = res.data.data.tag_groups) !== null && _tag_groups !== void 0 ? _tag_groups : [];
                            store.state.resource.tagIdsList = tagOptions1.value;
                            // 标签值管理
                            if (props.config.treeParams.group_type === 3) {
                                getTreeList(tagOptions1.value);
                            }
                            // 标签组管理
                            if (props.config.states === Operation.REVISE && props.config.treeParams.group_type === 1) {
                                getGroupList(tagOptions1.value);
                            }
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function initTreeData() {
                return _ref.apply(this, arguments);
            };
        }();
        watch(function() {
            return props.config.isRefresh;
        }, function(flag) {
            if (flag) {
                initTreeData();
            }
        }, {
            deep: true
        });
        onMounted(function() {
            if (props.config.noInitRefresh) {
                var _tagIdsList;
                tagOptions1.value = (_tagIdsList = store.state.resource.tagIdsList) !== null && _tagIdsList !== void 0 ? _tagIdsList : [];
            } else {
                initTreeData();
            }
        });
        return {
            cascaderRef: cascaderRef,
            tagOptions: tagOptions1,
            defaultProps: defaultProps,
            innerConfig: innerConfig,
            handleChange: handleChange
        };
    }
});
